// extracted by mini-css-extract-plugin
module.exports = {"me":"style_me__3fhVY","others":"style_others__1jm3i"};